import template from "./paperwork_loading_messages.html";
import en from "./en.json";
import es from "./es.json";

const LOADING_MESSAGE_INTERVAL_MS = 3000;
const LOADING_MESSAGES = [
    "paperworkLoadingMessages.GETTING_FORM_STARTED",
    "paperworkLoadingMessages.ADDING_DETAILS_FROM_IDS",
    "paperworkLoadingMessages.LOOKING_AT_PAST_FORMS",
    "paperworkLoadingMessages.MAKING_SURE_EVERYTHING_LOOKS_RIGHT",
    "paperworkLoadingMessages.FINDING_MATCHING_INFO",
    "paperworkLoadingMessages.BRINGING_COMPLETED_FORM_DETAILS",
    "paperworkLoadingMessages.PUTTING_DETAILS_IN_RIGHT_SPOTS",
    "paperworkLoadingMessages.DOUBLE_CHECKING_DATES_AND_NUMBERS",
    "paperworkLoadingMessages.ALMOST_READY_FOR_REVIEW",
];

class PaperworkLoadingMessagesController {
    /* @ngInject */
    constructor($interval) {
        this.$interval = $interval;
        this.loadingMessages = LOADING_MESSAGES;
        this.loadingMessageIndex = 0;
        this.loadingMessageIntervalPromise = null;
    }

    $onInit() {
        let ctrl = this;
        ctrl.loadingMessageIndex = 0;
        ctrl.loadingMessageIntervalPromise = ctrl.$interval(function () {
            ctrl.loadingMessageIndex =
                (ctrl.loadingMessageIndex + 1) % ctrl.loadingMessages.length;
        }, LOADING_MESSAGE_INTERVAL_MS);
    }

    $onDestroy() {
        let ctrl = this;
        if (ctrl.loadingMessageIntervalPromise) {
            ctrl.$interval.cancel(ctrl.loadingMessageIntervalPromise);
            ctrl.loadingMessageIntervalPromise = null;
        }
    }
}

export default {
    controller: PaperworkLoadingMessagesController,
    name: "paperworkLoadingMessages",
    template: template,
    translations: { en, es },
};
